export default __webpack_public_path__ + "static/video1-old-fbd5b5886cccd9a2be979ec2d5ae31b9.jpg";